module.exports = __webpack_public_path__ + "img/coinbankB36.0a95f184.jpg";